var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-logo d-flex align-center justify-center"},[_c('v-img',{staticClass:"spin-animation",attrs:{"src":_vm.logoSrc,"alt":_vm.altText,"max-width":"80","max-height":"80"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }